import React from 'react';
import './HowItWorks.css';

const steps = [
  {
    number: '01',
    icon: '📋',
    title: 'Your Profile & Dashboard',
    description:
      'Answer a quick onboarding questionnaire — your goal (build muscle, lose fat, improve fitness), training experience, available equipment, diet type, schedule and lifestyle. In return you get a personal home dashboard with weight tracking and muscle-group analytics, so you and the AI always know exactly where you stand.',
    images: [
      '/assets/images2/home_screen.png',
      '/assets/images2/weight_screen.png',
      '/assets/images2/muscle_analytics_screen.png',
      '/assets/images2/weight_analytics_screen.png',
      '/assets/images2/profile_screen.png',
    ],
  },
  {
    number: '02',
    icon: '🤖',
    title: 'AI Builds Your Plan',
    description:
      'FitMind\'s AI instantly generates a fully personalised training plan tailored to your exact profile — a full plan overview, a week-by-week breakdown and a detailed workout & exercise list. No templates. No copy-paste. A plan built specifically for you.',
    images: [
      '/assets/images2/full_plan_screen.png',
      '/assets/images2/plan_weeks_screen.png',
      '/assets/images2/workouts_exercises.png',
    ],
  },
  {
    number: '03',
    icon: '💪',
    title: 'Train with AI Guidance',
    description:
      'Follow your sessions in the app — see the exact sets, reps and weight to lift for every exercise based on what you logged before, and swap in an alternative exercise whenever equipment isn\'t available.',
    images: [
      '/assets/images2/alternative_exercise.png',
      '/assets/images2/single_exercise_screen.png',
      '/assets/images2/train_session_screen.png',
    ],
  },
  {
    number: '04',
    icon: '📊',
    title: 'AI Adapts Every Month',
    description:
      'After completing a workout, FitMind logs it and tracks your progress trends and exercise history over time. Volume, intensity and exercise selection are all recalibrated so you keep progressing month after month.',
    images: [
      '/assets/images2/workout_complete_screen.png',
      '/assets/images2/progress_screen.png',
      '/assets/images2/exercise_history_screen.png',
    ],
  },
];

const HowItWorks: React.FC = () => {
  return (
    <section className="how" id="how-it-works">
      <div className="container">
        <div className="how__header">
          <span className="section-label">How It Works</span>
          <h2 className="section-title">
            From signup to <span>your first PR</span><br />in 4 simple steps
          </h2>
          <p className="section-subtitle">
            No complicated setup. No confusing dashboards. Just a guided journey from day one.
          </p>
        </div>

        <div className="how__steps">
          {steps.map((step, i) => (
            <div className="how__step" key={i}>
              <div className="how__step-left">
                <div className="how__step-num">{step.number}</div>
                {i < steps.length - 1 && <div className="how__step-line" />}
              </div>

              <div className="how__step-body">
                <div className="how__step-icon">{step.icon}</div>
                <h3 className="how__step-title">{step.title}</h3>
                <p className="how__step-desc">{step.description}</p>
              </div>

              <div className="how__step-visual">
                {step.images.map((src, j) => (
                  <div
                    className="how__phone"
                    key={j}
                    style={{ '--phone-offset': j } as React.CSSProperties}
                  >
                    <div className="how__phone-notch" />
                    <img src={src} alt={`${step.title} screen ${j + 1}`} className="how__phone-img" loading="lazy" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
